export default __webpack_public_path__ + "static/SET_Hybrid_Logo-bc47fd3ae6f4d7ab6293caa4673fe802.svg";